<template>
  <div class="index-content">
    <section class="index-header">
      <div v-if="!loginFlag" class="header-section content-row">
        <el-button size="small" type="text" @click="handleToProtal" style="font-size: 14px">返回中小平台主页</el-button>
        <el-button size="small" type="text" @click="handleRegister" style="font-size: 14px">注册</el-button>
        <el-button size="small" type="text" @click="handleLogin" style="font-size: 14px">登录</el-button>
      </div>
      <div v-else class="header-section content-row">
        <el-button size="small" type="text" @click="handleToProtal" style="font-size: 14px">返回中小平台主页</el-button>
        <el-dropdown @command="handleDropDwonCommand">
            <span class="el-dropdown-link" style="font-size: 14px">欢迎您 {{userInfo.name}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="modify_pass">修改密码</el-dropdown-item>
            <el-dropdown-item command="my_company">我的企业</el-dropdown-item>
            <el-dropdown-item command="logout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
<!--        <el-button size="small" type="text" @click="handleLogout">退出</el-button>-->
      </div>
    </section>
    <section class="index-title">
      <div class="content-row title-bg">
        <div class="title">青海省中小企业诉求意见及保障支付受理平台</div>
        <span class="sub-title">Qinghai small and medium-sized enterprise appeal opinions and guarantee payment acceptance platform</span>
      </div>
    </section>
    <section class="index-nav">
      <el-menu
        class="content-row"
        router
        background-color="#0068BC"
        text-color="#FFFFFF"
        active-text-color="#FFFFFF"
        :default-active="$route.path"
        mode="horizontal">
        <el-menu-item index="/portal/index">
          <i class="el-icon-s-home"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="/portal/notify">
          <i class="el-icon-tickets"></i>
          <span slot="title">通知公告</span>
        </el-menu-item>
        <el-menu-item index="/portal/paymentAppeal">
          <i class="el-icon-money"></i>
          <span slot="title">保障支付</span>
        </el-menu-item>
        <el-menu-item index="/portal/enterpriseAppeal">
          <i class="el-icon-document"></i>
          <span slot="title">诉求意见</span>
        </el-menu-item>
        <el-menu-item index="/portal/appealProgress">
          <i class="el-icon-s-platform"></i>
          <span slot="title">诉求进展</span>
        </el-menu-item>
        <el-menu-item index="/portal/duty/list">
          <i class="el-icon-picture-outline-round"></i>
          <span slot="title">工作动态</span>
        </el-menu-item>
        <el-menu-item index="/portal/contact">
          <i class="el-icon-chat-line-square"></i>
          <span slot="title">联系我们</span>
        </el-menu-item>
      </el-menu>
    </section>
    <section class="index-main content-row">
      <router-view ref="childView"/>
    </section>
    <section class="index-bottom">
      <span>主管单位：青海省促进中小企业暨非公有制经济发展工作领导小组办公室</span>
      <div style="margin-top: 5px">
        copyright@青海经信中小企业服务有限公司版权所有 备案号：青ICP备16000881号-1
      </div>
    </section>
    <el-dialog width="50%" :visible.sync="registerDialogVisible" :close-on-click-modal="false" center>
      <el-tabs v-model="registerInfo.role">
        <el-tab-pane label="企业人员注册" name="enterprise">
          <el-form label-position="right" :rules="registerEnterpriseInfoRules" ref="registerRef" :model="registerInfo" label-width="150px">
            <el-form-item label="登录账号：" prop="account">
              <el-input v-model="registerInfo.account" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="登录密码：" prop="password">
              <el-input type="password" maxlength="50" v-model="registerInfo.password"></el-input>
            </el-form-item>
            <el-form-item label="企业名称：" prop="organization">
              <el-input v-model="registerInfo.organization"></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码：" prop="organizationCode">
              <el-input v-model="registerInfo.organizationCode" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="企业联系人：" prop="name">
              <el-input v-model="registerInfo.name" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="registerInfo.phone" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="验证码：" prop="captcha">
              <el-input v-model="registerInfo.captcha" maxlength="20">
                <el-button slot="append" type="text" @click.prevent="sendSmsCode()" style="color: #07438A;background: #FFFFFF;padding-left: 5px;padding-right: 5px;">{{sendText}}</el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="服务机构人员注册" name="organization">
          <el-form label-position="right" :rules="registerInfoRules" ref="registerRef" :model="registerInfo" label-width="100px">
            <el-form-item label="登录账号：" prop="account">
              <el-input v-model="registerInfo.account" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="登录密码：" prop="password">
              <el-input type="password" maxlength="50" v-model="registerInfo.password"></el-input>
            </el-form-item>
            <el-form-item label="机构名称：" prop="organization">
              <el-input v-model="registerInfo.organization"></el-input>
            </el-form-item>
            <el-form-item label="机构代码：" prop="organizationCode">
              <el-input v-model="registerInfo.organizationCode"></el-input>
            </el-form-item>
            <el-form-item label="联系人：" prop="name">
              <el-input v-model="registerInfo.name" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="registerInfo.phone" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="验证码：" prop="captcha">
              <el-input v-model="registerInfo.captcha" maxlength="20">
                <el-button slot="append" type="text" @click.prevent="sendSmsCode()" style="color: #07438A;background: #FFFFFF;padding-left: 5px;padding-right: 5px;">{{sendText}}</el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" style="width: 150px;" round @click="registerDialogVisible = false">取 消</el-button>
        <el-button type="main" style="width: 150px;" round @click="handleCreateAccount">注 册</el-button>
      </div>
    </el-dialog>
    <el-dialog width="50%" :visible.sync="loginDialogVisible" :close-on-click-modal="false" center>
      <el-tabs v-model="loginInfo.type">
        <el-tab-pane label="密码登录" name="account">
          <el-form label-position="right" :rules="accountLoginInfoRules" ref="accountLoginInfoRef" :model="accountLoginInfo" label-width="1px">
            <el-form-item prop="account">
              <el-input v-model="accountLoginInfo.account" placeholder="请输入账号" maxlength="50">
                <i style="font-size: 25px;" slot="prepend" class="el-icon-user"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="accountLoginInfo.password" placeholder="请输入密码" type="password" maxlength="50">
                <i style="font-size: 25px;" slot="prepend" class="el-icon-lock"></i>
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="短信登录" name="sms">
          <el-form label-position="right" :rules="phoneLoginInfoRules" ref="phoneLoginInfoRef" :model="phoneLoginInfo" label-width="1px">
            <el-form-item prop="phone">
              <el-input v-model="phoneLoginInfo.phone" placeholder="请输入手机号" maxlength="50">
                <i style="font-size: 25px;" slot="prepend" class="el-icon-mobile-phone"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="captcha">
              <el-input v-model="phoneLoginInfo.captcha" placeholder="请输入验证码" maxlength="50">
                <i style="font-size: 25px;" slot="prepend" class="el-icon-chat-dot-square"></i>
                <el-button slot="append" type="text" @click.prevent="sendLoginSmsCode()" style="color: #07438A;background: #FFFFFF;padding-left: 5px;padding-right: 5px;">{{sendText}}</el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button type="main" style="width: 150px;" round @click="handleLoginAccount">登 录</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="passInfoVisible" :close-on-click-modal="false">
      <el-form :model="passInfo" ref="passForm" :rules="passRules">
        <el-form-item label="旧密码" type="password" label-width="80px" prop="oldPass">
          <el-input type="password" v-model="passInfo.oldPass"></el-input>
        </el-form-item>
        <el-form-item label="新密码" type="password" label-width="80px" prop="newPass">
          <el-input type="password" v-model="passInfo.newPass"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" type="password" label-width="80px" prop="confrmPass">
          <el-input type="password" v-model="passInfo.confrmPass"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="passInfoVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveNewPass">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog width="80%" title="企业信息" :visible.sync="userInfoDialogVisible" :close-on-click-modal="false">
      <el-form label-position="right" :rules="userInfoRules" ref="userInfoRef" :model="myUserInfo" label-width="150px">
        <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="企业名称：" prop="organization">
            <el-input v-model="myUserInfo.organization"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="统一社会信用代码：" prop="organizationCode">
            <el-input v-model="myUserInfo.organizationCode" maxlength="18"></el-input>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="法人代表：" prop="legalPerson">
              <el-input v-model="myUserInfo.legalPerson"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人联系电话：" prop="legalPersonPhone">
              <el-input v-model="myUserInfo.legalPersonPhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业联系人：" prop="name">
              <el-input v-model="myUserInfo.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="myUserInfo.phone" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="电子邮箱：" prop="email">
              <el-input v-model="myUserInfo.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="从业人员：" prop="employee">
              <el-input v-model="myUserInfo.employee"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
        <el-form-item label="企业规模：" prop="enterpriseSize">
          <el-select v-model="myUserInfo.enterpriseSize" placeholder="请选择" style="width:100%">
            <el-option
              v-for="item in enterpriseSizeList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业性质：" prop="enterpriseType">
              <el-select v-model="myUserInfo.enterpriseType" placeholder="请选择" style="width:100%">
                <el-option
                  v-for="item in enterpriseTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="注册资本：" prop="registerMoney">
              <el-input v-model="myUserInfo.registerMoney"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册时间：" prop="registerTime">
              <el-date-picker
                style="width: 100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="myUserInfo.registerTime">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="注册地址：" prop="registerAddress">
              <el-select
                style="width: 100%"
                v-model="myUserInfo.registerAddress"
                filterable
                placeholder="请输入地区/园区">
                <el-option
                  v-for="item in parkList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册详细地址：" prop="registerDetailAddress">
              <el-input v-model="myUserInfo.registerDetailAddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业所在地：" prop="locationArea">
              <el-select
                style="width: 100%"
                v-model.number="myUserInfo.locationArea"
                filterable
                placeholder="请输入地区/园区">
                <el-option
                  v-for="item in parkList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在地详细地址：" prop="address">
              <el-input v-model="myUserInfo.address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="营业执照：" prop="licenseUrl">
              <el-upload
                class="upload-demo"
                action="/appeal/file/upload/userLicense"
                :on-success="handleLicenseSuccess"
                :on-remove="handleLicenseRemove"
                multiple
                :file-list="licenseFileList">
                <el-button icon="el-icon-upload" type="main">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="真实承诺书：" prop="commitmentUrl" style="position: relative">
              <el-upload
                style="width: 100%"
                action="/appeal/file/upload/userCommitment"
                :on-success="handleCommitmentSuccess"
                :on-remove="handleCommitmentRemove"
                multiple
                :file-list="commitmentFileList">
                <el-button icon="el-icon-upload" type="main">点击上传</el-button>
              </el-upload>
              <div style="position: absolute;top: 5px;left: 130px;">
                <el-link style="color: #0068BC" :underline="false" href="../../static/承诺书模版.docx">承诺书模版下载</el-link>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="main" style="width: 150px;" round @click="handleUserInfoUpdate">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import md5 from 'js-md5'
  import { userRegisterSms, userRegister,portalUserModifyPass, portalUserInfo, portalUserAccountLogin, portalUserSmsLogin, portalUserLogout, portalDictionary, portalUserUpdate, portalParkList} from '@/api/restapi.js'
  export default {
    data () {
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.passInfo.newPass) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      return {
        userInfoDialogVisible: false,
        registerDialogVisible: false,
        loginDialogVisible: false,
        passInfoVisible: false,
        enableSend: true,
        loginFlag: false,
        parkList: [],
        enterpriseSizeList: [],
        enterpriseTypeList: [],
        licenseFileList: [],
        commitmentFileList: [],
        sendText: '获取验证码',
        userInfo: {},
        myUserInfo: {},
        registerInfo: {
          role: 'enterprise'
        },
        loginInfo: {
          type: 'account'
        },
        passInfo: {},
        accountLoginInfo: {
          account: '',
          password: ''
        },
        phoneLoginInfo: {
          phone: '',
          captcha: ''
        },
        passRules: {
          oldPass: [
            { required: true, message: '请输入旧密码', trigger: 'blur' }
          ],
          newPass: [
            { required: true, message: '请输入新密码', trigger: 'blur' }
          ],
          confrmPass: [
            { required: true, validator: validatePass2, trigger: 'blur' }
          ]
        },
        userInfoRules: {
          organization: [
            { required: true, message: '请输入企业名称', trigger: 'blur' }
          ],
          organizationCode: [
            { required: true, message: '请输入18位统一社会信用代码', trigger: 'blur' },
            { min: 18, max: 18,message: '请输入18位统一社会信用代码', trigger: 'blur' },
            { pattern:/^[A-Za-z0-9]+$/, message: '只能输入数字、字母', trigger: 'blur'}
          ],
          legalPerson: [
            { required: true, message: '请输入法人代表', trigger: 'blur' }
          ],
          legalPersonPhone: [
            { required: true, message: '请输入法人联系电话', trigger: 'blur' }
          ],
          name: [
            { required: true, message: '请填写企业联系人', trigger: 'blur' }
          ],
          phone: [
            { required: true, message: '请填写联系电话', trigger: 'blur' }
          ],
          email: [
            { required: true, message: '请填写电子邮箱', trigger: 'blur' }
          ],
          employee: [
            { required: true, message: '请填写从业人员', trigger: 'blur' }
          ],
          enterpriseSize: [
            { required: true, message: '请选择企业规模', trigger: 'change' }
          ],
          enterpriseType: [
            { required: true, message: '请选择企业性质', trigger: 'change' }
          ],
          registerMoney: [
            { required: true, message: '请填写注册资本', trigger: 'blur' }
          ],
          registerTime: [
            { required: true, message: '请填写注册时间', trigger: 'blur' }
          ],
          registerAddress: [
            { required: true, message: '请选择注册地址', trigger: 'blur' }
          ],
          registerDetailAddress: [
            { required: true, message: '请填写注册详细地址', trigger: 'blur' }
          ],
          locationArea: [
            { required: true, message: '请选择企业所在地', trigger: 'blur' }
          ],
          address: [
            { required: true, message: '请填写通讯地址', trigger: 'blur' }
          ],
          licenseUrl: [
            { required: true, message: '请上传营业执照', trigger: 'blur' }
          ],
          commitmentUrl: [
            { required: true, message: '请上传真实承诺书', trigger: 'blur' }
          ],
        },
        accountLoginInfoRules: {
          account: [
            { required: true, message: '请填写账号', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请填写密码', trigger: 'blur' }
          ]
        },
        phoneLoginInfoRules: {
          phone: [
            { required: true, message: '请填写手机号', trigger: 'blur' }
          ],
          captcha: [
            { required: true, message: '请填写验证码', trigger: 'blur' }
          ]
        },
        registerInfoRules: {
          name: [
            { required: true, message: '请填写姓名', trigger: 'blur' }
          ],
          account: [
            { required: true, message: '请填写账号', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请填写密码', trigger: 'blur' }
          ],
          organization: [
            { required: true, message: '请填写名称', trigger: 'blur' }
          ],
          organizationCode: [
            { required: true, message: '请填写代码', trigger: 'blur' }
          ],
          phone: [
            { required: true, message: '请填写手机号', trigger: 'blur' }
          ],
          captcha: [
            { required: true, message: '请填写验证码', trigger: 'blur' }
          ]
        },
        registerEnterpriseInfoRules: {
          name: [
            { required: true, message: '请填写姓名', trigger: 'blur' }
          ],
          account: [
            { required: true, message: '请填写账号', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请填写密码', trigger: 'blur' }
          ],
          organization: [
            { required: true, message: '请填写联系人名称', trigger: 'blur' }
          ],
          organizationCode: [
            { required: true, message: '请输入18位统一社会信用代码', trigger: 'blur' },
            { min: 18, max: 18,message: '请输入18位统一社会信用代码', trigger: 'blur' },
            { pattern:/^[A-Za-z0-9]+$/, message: '只能输入数字、字母', trigger: 'blur'}
          ],
          phone: [
            { required: true, message: '请填写联系电话', trigger: 'blur' }
          ],
          captcha: [
            { required: true, message: '请填写验证码', trigger: 'blur' }
          ]
        }
      }
    },
    mounted () {
      this.initUser()
      portalDictionary('enterprise_size').then(res => {
        if (res.data.code === 0) {
          this.enterpriseSizeList = res.data.data
        }
      })
      portalDictionary('enterprise_type').then(res => {
        if (res.data.code === 0) {
          this.enterpriseTypeList = res.data.data
        }
      })
      this.queryParkAsync('')
    },
    methods: {
      showErrorMsg(msg){
        this.$message({
          type: 'error',
          message: msg,
          customClass: 'msg-index'
        })
      },
      queryParkAsync (queryString, cb) {
        portalParkList(queryString).then(res => {
          if (res.data.code === 0) {
            let names = []
            res.data.data.list.forEach(o => {
              names.push({
                value: o.name,
                id: o.id
              })
            })
            this.parkList = names
          }
        })
      },
      handleLicenseSuccess (res,file) {
        this.myUserInfo.licenseUrl.push({
          fileName: file.name,
          fileUrl: file.response.data
        })
      },
      handleLicenseRemove (res, file) {
        let att = []
        file.forEach(f => {
          att.push({
            fileName: f.name,
            fileUrl: f.response.data
          })
        })
        this.myUserInfo.licenseUrl = att
      },
      handleCommitmentSuccess (res,file) {
        this.myUserInfo.commitmentUrl.push({
          fileName: file.name,
          fileUrl: file.response.data
        })
      },
      handleCommitmentRemove (res, file) {
        let att = []
        file.forEach(f => {
          att.push({
            fileName: f.name,
            fileUrl: f.response.data
          })
        })
        this.myUserInfo.commitmentUrl = att
      },
      handleDropDwonCommand (command) {
        switch (command) {
          case 'logout':
            this.handleLogout()
            break
          case 'my_company':
            this.myUserInfo = Object.assign({},this.userInfo)
            if (this.userInfo.locationArea) {
              this.myUserInfo.locationArea = parseInt(this.userInfo.locationArea)
            }
            if (this.userInfo.registerAddress) {
              this.myUserInfo.registerAddress = parseInt(this.userInfo.registerAddress)
            }
            this.commitmentFileList = []
            if (this.userInfo.commitmentUrl) {
              this.userInfo.commitmentUrl.forEach(file => {
                this.commitmentFileList.push({
                  name: file.fileName,
                  response: {
                    data: file.fileUrl
                  }
                })
              })
            }
            this.licenseFileList = []
            if (this.userInfo.licenseUrl) {
              this.userInfo.licenseUrl.forEach(file => {
                this.licenseFileList.push({
                  name: file.fileName,
                  response: {
                    data: file.fileUrl
                  }
                })
              })
            }
            this.userInfoDialogVisible = true
            break
          case 'modify_pass':
            this.passInfo = Object.assign({},{})
            this.passInfoVisible = true
            break
        }
      },
      initUser () {
        portalUserInfo().then(res => {
          if (res.data.code === 0) {
            this.userInfo = res.data.data
            if (this.userInfo) {
              this.loginFlag = true
            }
          }
        })
      },
      handleUserInfoUpdate () {
        let val = this.valForm('userInfoRef')
        if (!val) {
          return
        }
        portalUserUpdate(this.myUserInfo).then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.userInfoDialogVisible = false
            this.userInfo = Object.assign({},this.myUserInfo)
            if (this.$refs.childView.updateUserInfo) {
              this.$refs.childView.updateUserInfo(this.userInfo)
            }
          }else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        })
      },
      sendLoginSmsCode () {
        if(!this.phoneLoginInfo.phone){
          this.$message({
            message: '请填写手机号',
            type: 'error'
          })
          return
        }
        if (!this.enableSend) {
          return
        }
        this.enableSend = true
        userRegisterSms(this.phoneLoginInfo.phone, 'login').then(res => {
          if (res.data.code === 0) {
            this.startSendCount()
            this.$message({
              message: '验证码已发送',
              type: 'success'
            })
          }else {
            this.enableSend = true
            this.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        })
      },
      sendSmsCode () {
        if(!this.registerInfo.phone){
          this.$message({
            message: '请填写手机号',
            type: 'error'
          })
          return
        }
        if (!this.enableSend) {
          return
        }
        this.enableSend = true
        userRegisterSms(this.registerInfo.phone, 'register').then(res => {
          if (res.data.code === 0) {
            this.startSendCount()
            this.$message({
              message: '验证码已发送',
              type: 'success'
            })
          }else {
            this.enableSend = true
            this.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        })
      },
      startSendCount () {
        let time = 60
        let clock = window.setInterval(() => {
          this.sendText = time + 's后重新发送'
          time --
          if (time<=0) {
            window.clearInterval(clock)
            this.sendText = '发送验证码'
            this.enableSend = true
          }
        },1000)
      },
      handleToProtal () {
        window.open('http://www.smeqh.cn/web/#/','_blank')
      },
      saveNewPass () {
        let isValid = true
        this.$refs['passForm'].validate((valid) => {
          if (!valid) {
            isValid = false
          }
        })
        if (!isValid) {
          return
        }
        portalUserModifyPass(md5(this.passInfo.oldPass),md5(this.passInfo.newPass)).then(res => {
          if (res.data.code === 0) {
            this.passInfoVisible = false
            this.$message({
              showClose: true,
              message: '修改成功',
              type: 'success'
            })
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error'
            })
          }
        }).catch(err => {
          this.$message({
            showClose: true,
            message: '密码修改失败',
            type: 'error'
          })
        })
      },
      handleLogout () {
        portalUserLogout().then(res => {
          this.userInfo = ''
          this.loginFlag = false
        })
      },
      handleLogin () {
        this.accountLoginInfo = {}
        this.phoneLoginInfo = {}
        this.loginDialogVisible = true
      },
      handleLoginAccount () {
        if (this.loginInfo.type === 'account') {
          let val = this.valForm('accountLoginInfoRef')
          if (!val) {
            return
          }
          this.accountLoginInfo.password = md5(this.accountLoginInfo.password)
          portalUserAccountLogin(this.accountLoginInfo.account,this.accountLoginInfo.password).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '登录成功',
                type: 'success'
              })
              this.loginDialogVisible = false
              this.$router.replace({
                path: '/refresh',
                query: {
                  t: Date.now()
                }
              })
            }else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          let val = this.valForm('phoneLoginInfoRef')
          if (!val) {
            return
          }
          portalUserSmsLogin(this.phoneLoginInfo.phone,this.phoneLoginInfo.captcha).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '登录成功',
                type: 'success'
              })
              this.loginDialogVisible = false
              this.$router.replace({
                path: '/refresh',
                query: {
                  t: Date.now()
                }
              })
            }else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          }).catch(err => {
            console.log(err)
          })
        }
      },
      handleRegister () {
        this.registerDialogVisible = true
        if (this.$refs['registerRef']) {
          this.$refs['registerRef'].clearValidate()
        }
      },
      handleCreateAccount () {
        let val = this.valForm('registerRef')
        if (!val) {
          return
        }
        userRegister(this.registerInfo).then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '注册成功',
              type: 'success'
            })
            this.registerDialogVisible = false
            this.initUser()
          }else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        }).catch(err => {
          console.log(err)
        })
      },
      valForm (formRef) {
        let isValid = true
        this.$refs[formRef].validate((valid) => {
          if (!valid) {
            isValid = false
          }
        })
        if (!isValid) {
          this.$message({
            showClose: true,
            message: '请检查填写内容',
            type: 'error'
          })
        }
        return isValid
      }
    }
  }
</script>
<style>
  @import "../../style/Table.css";
  .index-content {
    height: 100%;
    width: 100%;
  }
  .index-header {
    position: relative;
    z-index: 99;
    height: 30px;
    width: 100%;
    background: #f2f5f6;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  }
  .content-row {
    max-width: 1400px;
  }
  .header-section {
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin: 0 auto;
  }
  .header-section .el-button--text {
    color: #0068BC;
  }
  .index-title {
    margin: 0 auto;
    background: #4c95d0;
    height: 200px;
  }
  .index-title .title-bg{
    margin: 0 auto;
    height: 100%;
    background: url("/static/ic_title_bg.jpg") no-repeat bottom;
  }
  .index-title .title {
    font-size: 30px;
    font-weight: 800;
    color: #FFFFFF;
    padding-top: 70px;
  }
  .index-title .sub-title{
    font-size: 12px;
    font-weight: 800;
    color: #FFFFFF;
  }
  .index-nav {
    background: #0068BC;
    width: 100%;
    padding: 0;
    height: 40px;
  }
  .index-nav .el-menu {
    margin: 0 auto;
    padding: 0;
    border-bottom: none;
  }
  .index-nav .el-menu .el-menu-item {
    width: 14.25%;
    height: 38px;
    line-height: 38px;
    text-align: center;
    color: #FFFFFF;
    font-size: 17px;
    font-weight: 800;
  }
  .index-nav .el-menu .el-menu-item.is-active {
    background: #00509B !important;
    border-bottom: 0px;
  }
  .index-nav .el-menu .el-menu-item.is-active:after{
    content: "";
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #fff;
    position: absolute;
    bottom: -2px;
    left: 50%;
  }
  .index-nav .el-menu .el-menu-item i {
    color: #FFFFFF;
    font-size: 25px;
  }
  .index-main {
    margin: 10px auto;
    padding: 0;
  }
  .index-bottom {
    background: #0068BC;
    text-align: center;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    color: #ffffff;
    font-size: 13px;
  }
  .el-dialog--center .el-dialog__body {
    padding-top: 2px;
    padding-bottom: 5px;
  }
  .el-dropdown-link {
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    color: #0068BC;
  }
  .msg-index {
    z-index: 3000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/portal/Portal.vue